import styles from './ProjectsPageShell.module.css';

/**
 * Shared layout for Projects hub pages: title, optional subtitle/callout,
 * consistent loading and error treatment.
 */
export default function ProjectsPageShell({
    title,
    subtitle,
    callout,
    loading = false,
    error = null,
    onRetry,
    headerActions = null,
    children,
}) {
    return (
        <div className={styles.shell}>
            <header className={styles.header}>
                <div className={styles.headerText}>
                    <h1 className={styles.title}>{title}</h1>
                    {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
                </div>
                {headerActions ? <div className={styles.headerActions}>{headerActions}</div> : null}
            </header>
            {callout ? <div className={styles.callout}>{callout}</div> : null}
            {loading ? <p className={styles.loading}>Loading…</p> : null}
            {!loading && error ? (
                <div className={styles.errorBox} role="alert">
                    <p className={styles.errorText}>{error}</p>
                    {onRetry ? (
                        <button type="button" className={styles.retryBtn} onClick={onRetry}>
                            Retry
                        </button>
                    ) : null}
                </div>
            ) : null}
            {!loading && !error ? children : null}
        </div>
    );
}
